import {handleActions} from 'redux-actions'
import {LOCATION_CHANGE} from 'connected-react-router'
import * as type from './type'
import {TAB_BASIC_DATA} from './const'

export const initialState = {
    customer: null,
    fetching: false,
    error: null,
    hasChanged: false,
    showImages: false,
    accountFix: null,
    startProcessFetching: false,
    responseFeedback: {
        responseFeedbackModalOpen: false,
        responseValue: null,
        status: null,
    },
    changeEmailData: {
        changeEmailModalOpen: false,
        newEmail: null,
        emailAlreadyInUse: false,
    },
    deleteConfirmationModal: {
        open: false,
        checked: false,
        warning: false
    },
    contact: {
        id: null,
        gender: null,
        referenceNumber: null,
        firstName: null,
        lastName: null,
        streetAddress: null,
        streetAddressExtension: null,
        staircase: null,
        door: null,
        zip: null,
        city: null,
        countryCode: null,
        language: null,
        email: null,
        phone: null,
        dob: null,
        store: null,
        socialSecurityNumber: null,
    },
    tab: TAB_BASIC_DATA,
    imageFetching: {
        'face-smiling': false,
        face: false,
        profile: false,
        'upper-tooth-sector': false,
        'bottom-tooth-sector': false,
        'right-side': false,
        frontal: false,
        'left-side': false,
    },
}


export default handleActions({

    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...initialState
        }
    },
    [type.CHANGE_ACTIVE_TAB]: (state, action) => {
        const {tab} = action.payload
        return {
            ...state,
            tab,
        }
    },
    [type.FIND_CUSTOMER_PARTIAL_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.FIND_CUSTOMER_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            customer: null,
        }
    },
    [type.FIND_CUSTOMER_SUCCESS]: (state, action) => {
        const {customer} = action.payload
        return {
            ...state,
            customer: {
                ...state.customer,
                ...customer
            },
            fetching: false,
        }
    },
    [type.FIND_CUSTOMER_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.HYDRATE_CUSTOMER_CONTACT]: (state, action) => {
        const {customer} = state
        return {
            ...state,
            contact: {
                id: customer.id,
                gender: customer.gender,
                referenceNumber: customer.referenceNumber,
                firstName: customer.firstName,
                lastName: customer.lastName,
                streetAddress: customer.streetAddress,
                streetAddressExtension: customer.streetAddressExtension,
                staircase: customer.staircase,
                door: customer.door,
                zip: customer.zip,
                city: customer.city,
                countryCode: customer.countryCode,
                language: customer.language,
                email: customer.email,
                phone: customer.phone,
                dob: customer.dob,
                store: customer.store,
                socialSecurityNumber: customer.socialSecurityNumber,
            }
        }
    },
    [type.CHANGE_CUSTOMER]: (state, action) => {
        const {name, value} = action.payload
        return {
            ...state,
            hasChanged: true,
            customer: {
                ...state.customer,
                [name]: value,
            },
        }
    },
    [type.CHANGE_CUSTOMER_CONTACT]: (state, action) => {
        const {name, value} = action.payload
        return {
            ...state,
            hasChanged: true,
            contact: {
                ...state.contact,
                [name]: value,
            },
        }
    },
    [type.UPLOAD_CUSTOMER_IMAGE_REQUEST]: (state, action) => {
        const {fileName} = action.payload
        return {
            ...state,
            imageFetching: {
                ...state.imageFetching,
                [fileName]: true,
            },
            fetching: true,
            error: null,
        }
    },
    [type.UPLOAD_CUSTOMER_IMAGE_SUCCESS]: (state, action) => {
        const {file} = action.payload
        let imageReplaced = false

        const imageList = state.customer.imageList.map((image) => {
            if (image.fileName === file.fileName) {
                imageReplaced = true
                return file
            }
            return image
        })
        if (!imageReplaced) {
            imageList.push(file)
        }

        return {
            ...state,
            customer: {
                ...state.customer,
                imageList: [
                    ...imageList,
                ],
            },
            imageFetching: {
                ...state.imageFetching,
                [file.fileName]: false,
            },
            fetching: false,
        }
    },
    [type.UPLOAD_CUSTOMER_IMAGE_ERROR]: (state, action) => {
        const {error, fileName} = action.payload
        return {
            ...state,
            fetching: false,
            error,
            imageFetching: {
                ...state.imageFetching,
                [fileName]: false,
            },
        }
    },
    [type.ADD_CUSTOMER_FILE]: (state, action) => {
        const {fileType, file} = action.payload
        let found = false
        const fileList = state.customer[fileType].map(existingFile => {
            found = found || (existingFile.id === file.id)
            return (existingFile.id === file.id) ? file : existingFile
        })
        if (!found) {
            fileList.push(file)
        }

        return {
            ...state,
            customer: {
                ...state.customer,
                [fileType]: fileList,
            },
        }
    },
    [type.SET_FILE_DELETE_FLAG]: (state, action) => {
        const {fileType, fileId} = action.payload

        const fileList = state.customer[fileType].map(file => {
            return (file.id !== fileId) ? file : {
                ...file,
                deleted: true,
            }
        })
        return {
            ...state,
            customer: {
                ...state.customer,
                [fileType]: fileList,
            },
        }
    },
    [type.TOGGLE_IMAGE_VIEW]: (state, action) => {
        return {
            ...state,
            showImages: !state.showImages,
        }
    },
    [type.SAVE_CUSTOMER_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_CUSTOMER_SUCCESS]: (state, action) => {
        const {customer} = action.payload
        return {
            ...state,
            customer,
            fetching: false,
        }
    },
    [type.SAVE_CUSTOMER_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.START_ESCALATION_PROCESS_REQUEST]: (state, action) => {
        return {
            ...state,
            startProcessFetching: true,
            fetching: true,
        }
    },
    [type.START_ESCALATION_PROCESS_SUCCESS]: (state, action) => {
        const {customer} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            customer,
        }
    },
    [type.START_ESCALATION_PROCESS_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            error,
        }
    },
    [type.START_PARTIAL_REFUND_PROCESS_REQUEST]: (state, action) => {
        return {
            ...state,
            startProcessFetching: true,
            fetching: true,
        }
    },
    [type.START_PARTIAL_REFUND_PROCESS_SUCCESS]: (state, action) => {
        const {customer} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            customer,
        }
    },
    [type.START_PARTIAL_REFUND_PROCESS_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            error,
        }
    },
    [type.START_REFINEMENT_SET_PROCESS_REQUEST]: (state, action) => {
        return {
            ...state,
            startProcessFetching: true,
            fetching: true,
        }
    },
    [type.START_REFINEMENT_SET_PROCESS_SUCCESS]: (state, action) => {
        const {customer} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            customer,
        }
    },
    [type.START_REFINEMENT_SET_PROCESS_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            error,
        }
    },
    [type.START_REFINEMENT_SHOP_PROCESS_REQUEST]: (state, action) => {
        return {
            ...state,
            startProcessFetching: true,
            fetching: true,
        }
    },
    [type.START_REFINEMENT_SHOP_PROCESS_SUCCESS]: (state, action) => {
        const {customer} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            customer,
        }
    },
    [type.START_REFINEMENT_SHOP_PROCESS_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            error,
        }
    },
    [type.START_RETAINER_REFINEMENT_PROCESS_REQUEST]: (state, action) => {
        return {
            ...state,
            startProcessFetching: true,
            fetching: true,
        }
    },
    [type.START_RETAINER_REFINEMENT_PROCESS_SUCCESS]: (state, action) => {
        const {customer} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            customer,
        }
    },
    [type.START_RETAINER_REFINEMENT_PROCESS_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            startProcessFetching: false,
            fetching: false,
            error,
        }
    },
    [type.FIX_ACCOUNT_PROBLEM_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            accountFix: null,
        }
    },
    [type.FIX_ACCOUNT_PROBLEM_SUCCESS]: (state, action) => {
        const {accountFix} = action.payload
        return {
            ...state,
            fetching: false,
            accountFix,
        }
    },
    [type.FIX_ACCOUNT_PROBLEM_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.OPEN_CHANGE_EMAIL_MODAL]: (state, action) => {
        return {
            ...state,
            changeEmailData: {
                ...state.changeEmailData,
                changeEmailModalOpen: true,
            },
        }
    },
    [type.CLOSE_CHANGE_EMAIL_MODAL]: (state, action) => {
        return {
            ...state,
            changeEmailData: {
                ...state.changeEmailData,
                changeEmailModalOpen: false,
            },
        }
    },
    [type.CHANGE_NEW_EMAIL]: (state, action) => {
        const {value} = action.payload
        return {
            ...state,
            changeEmailData: {
                ...state.changeEmailData,
                newEmail: value,
            },
        }
    },
    [type.CHANGE_EMAIL_REQUEST]: (state, action) => {
        return {
            ...state,
            changeEmailData: {
                ...state.changeEmailData,
                emailAlreadyInUse: false,
            },
            fetching: true,
        }
    },
    [type.CHANGE_EMAIL_SUCCESS]: (state, action) => {
        const {email} = action.payload
        return {
            ...state,
            changeEmailData: {
                ...state.changeEmailData,
                newEmail: null,
                changeEmailModalOpen: false,
            },
            customer: {
                ...state.customer,
                email,
            },
        }
    },
    [type.CHANGE_EMAIL_ERROR]: (state, action) => {
        return {
            ...state,
            changeEmailData: {
                ...state.changeEmailData,
                emailAlreadyInUse: true,
            },
        }
    },
    [type.FIND_PROCESS_COMMENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.FIND_PROCESS_COMMENT_SUCCESS]: (state, action) => {
        const {processList} = action.payload
        return {
            ...state,
            customer: {
                ...state.customer,
                processList,
            },
            fetching: false,
        }
    },
    [type.FIND_PROCESS_COMMENT_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            error,
            fetching: false,
        }
    },
    [type.START_DOWNLOAD_CUSTOMER_DATA_SUCCESS]: (state, action) => {
        return {
            ...state,
            responseFeedback: {
                responseFeedbackModalOpen: true,
                responseValue: true,
                status: 101
            },
        }
    },
    [type.START_DOWNLOAD_CUSTOMER_DATA_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            error,
            responseFeedback: {
                responseFeedbackModalOpen: true,
                responseValue: false,
                status: 401
            },
        }
    },
    [type.CLOSE_RESPONSE_FEEDBACK_MODAL]: (state, action) => {
        return {
            ...state,
            responseFeedback: {
                responseFeedbackModalOpen: false,
                responseValue: null,
                status: null,
            },
        }
    },
    [type.OPEN_DELETE_CONFIRMATION_MODAL]: (state, action) => {
        return {
            ...state,
            deleteConfirmationModal: {
                open: true,
                checked: false,
            }
        }
    },
    [type.CLOSE_DELETE_CONFIRMATION_MODAL]: (state, action) => {
        return {
            ...state,
            deleteConfirmationModal: {
                open: false,
                checked: false,
            }
        }
    },
    [type.HANDLE_DELETE_CONFIRMATION_MODAL]: (state, action) => {
        const {value} = action.payload
        return {
            ...state,
            deleteConfirmationModal: {
                ...state.deleteConfirmationModal,
                checked: value,
                warning: !value
            }
        }
    },
    [type.SHOW_ERROR_CONFIRMATION_MODAL]: (state, action) => {
        return {
            ...state,
            deleteConfirmationModal: {
                ...state.deleteConfirmationModal,
                warning: true
            }
        }
    },
    [type.DELETE_CUSTOMER_SUCCESS]: (state, action) => {
        const {response} = action.payload
        return {
            ...state,
            responseFeedback: {
                responseValue: true,
                responseFeedbackModalOpen: true,
                status: response.deleteStatus
            },
        }
    },
    [type.DELETE_CUSTOMER_ERROR]: (state, action) => {
        return {
            ...state,
            responseFeedback: {
                responseValue: false,
                responseFeedbackModalOpen: true,
                status: 400
            },
        }
    },

    [type.SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_SUCCESS]: (state, action) => {
        const { treatmentExecutionList } = action.payload
        return {
            ...state,
            fetching: false,
            hasChanged: true,
            customer: {
                ...state.customer,
                treatmentExecutionList:[
                    treatmentExecutionList
                ]
            },
        }
    },
    [type.SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.UPDATE_WHATSAPP_OPT_IN_REQUEST]: (state) => {
        return {
            ...state,
            fetching: true
        }
    },
    [type.UPDATE_WHATSAPP_OPT_IN_SUCCESS]: (state,action) => {
        const { value } = action.payload
        return {
            ...state,
            customer: {
                ...state.customer,
                isWhatsAppOptIn: value,
            },
            responseFeedback: {
                responseFeedbackModalOpen: true,
                responseValue: true,
                status:601
            },
            fetching: false,
        }
    },
    [type.UPDATE_WHATSAPP_OPT_IN_ERROR]: (state) => {
        return {
            ...state,
            fetching: false,
            responseFeedback: {
                responseFeedbackModalOpen: true,
                responseValue: false,
                status:600
            },
        }
    },
    [type.UPDATE_WHATSAPP_OPT_IN_NON_VALID_VALUE]: (state) => {
        return {
            ...state,
            fetching: false,
            responseFeedback: {
                responseFeedbackModalOpen: true,
                responseValue: false,
                status:602
            },
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/reducer.js